export function getDay(date) { 
  let month = '0'
  if (date.getMonth() <= 8) {
    month += (date.getMonth() + 1).toString()
  } else {
    month = (date.getMonth() + 1).toString()
  }
  let day = '0'
  if (date.getDate() < 10) {
    day += date.getDate().toString()
  } else {
    day = date.getDate().toString()
  }
  return date.getFullYear()+'-'+month+'-'+day
}

export function getTime(date) {
  return date.toLocaleTimeString()
}

export function getTimeIn24(date) {
  return date.toTimeString()
}


// WEBPACK FOOTER //
// ./src/util/datetime.js